module.exports = __webpack_public_path__ + "static/img/wdtx1-1.51a833b.png";


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/word/wdtx1-1.png
// module id = 894
// module chunks = 0